<template>
    <div>   
        <v-card class="mb-4">
            <v-row class="ml-1 mr-1">
                <v-col cols="11">
                    <v-card-title class="titulopagina">REGISTRO DE HORAS OPERATIVAS</v-card-title>
                </v-col>
                <v-col cols="1">
                    <v-alert class="amber accent-2 text-center" color="orange" outlined dense @click="abrirAyudas">
                        <v-icon color="blue" large>help</v-icon>
                    </v-alert>
                </v-col>
            </v-row>
        </v-card>
        <modal-ayuda></modal-ayuda>
        <v-row>
            <v-col cols="8">
                <v-row class="ml-1 mr-1" v-if="alert">
                    <v-alert dense text type="success">
                    {{ alertMessage }}<v-btn icon class="float-right" color="green darken-3" @click="alert=!alert"><v-icon>cancel</v-icon></v-btn>
                    </v-alert>
                </v-row>
            </v-col>
            <v-col cols="4">
                <v-col class="col-md-12 col-sm-12">
                    <date-picker class="float-right" v-model="fechas" @change="cargarHoras"
                        range-separator="|" range placeholder ="Búsqueda por Fechas" 
                        format="DD-MM-YYYY" :default-value="fechas" valueType="YYYY-MM-DD">
                    </date-picker>
                    <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
                </v-col>
            </v-col>
        </v-row>
        <v-row class="ml-1 mr-1">
            <v-col class="col-md-4 col-sm-12">
                <v-card class="pb-2">
                    <v-row class="ml-1 mr-1">
                        <v-col class="col-md-3 col-sm-6">
                            Fecha*
                        </v-col>
                        <v-col class="col-md-9 col-sm-6">
                            <date-picker 
                                v-model="hora.fecha" 
                                placeholder ="Seleccione Fecha" 
                                format="DD-MM-YYYY" 
                                :default-value="hora.fecha" 
                                valueType="YYYY-MM-DD"
                            ></date-picker>
                        </v-col>
                    </v-row>
                    <v-row class="ml-1 mr-1">
                        <v-col class="col-12">
                            <v-select
                                :items="turnos"
                                item-text="nombre"
                                item-value="id"
                                v-model="hora.turnos_id"
                                label="Turno *"
                            ></v-select>
                        </v-col>
                    </v-row>
                    <v-row class="ml-1 mr-1">
                        <v-col class="col-12">
                            <v-text-field v-model="hora.linea1" label="Horas Operativas Línea 1 *" placeholder="Horas Operativas Línea 1*" type="number" step=""></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="ml-1 mr-1">
                        <v-col class="col-12">
                            <v-text-field v-model="hora.linea2" label="Horas Operativas Línea 2 *" placeholder="Horas Operativas Línea 2*" type="number" step="1"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="ml-1 mr-1">
                        <v-col class="col-12">
                            <v-text-field v-model="hora.diario" label="Horas Planta Harina *" placeholder="Horas Planta Harina*" type="number" step="1"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="ml-1 mr-1">
                        <v-col class="col-12">
                            <v-text-field v-model="hora.linea3" label="Horas Planta Hidrolizado *" placeholder="Horas Planta Hidrolizado*" type="number" step="1"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="ml-1 mr-1">
                        <v-col class="col-12">
                            <v-text-field v-model="hora.observacion" label="Observación" placeholder="Observación"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="ml-1 mr-1">
                        <v-col class="col-12 py-0 caption">
                            Para habilitar botón de registrar/modificar, debe rellenar todos los campos marcados como obligatorio (*).
                        </v-col>
                    </v-row>
                    <v-row class="ml-1 mr-1">
                        <v-col class="text-center">
                            <v-btn class="green darken-1" dark @click="generarRegistroHoras" :disabled="!campos_validos">{{ registro }}</v-btn>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
            <v-col>
                <v-data-table :headers="encabezado" :items="horas" :item-class="rowClass" class="elevation-1">
                    <template v-slot:item.turnos_id="{ item }">
                        <span>{{ turnos.find(turno => turno.id === item.turnos_id) && turnos.find(turno => turno.id === item.turnos_id).nombre }}</span>
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <v-icon class="mr-6" @click=seleccionar(item)>edit</v-icon>
                        <v-btn color="red darken-4" dark small icon @click="eliminar(item)">
                            <v-icon>delete</v-icon>
                        </v-btn>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
//datepicker vue2
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
import ConfirmDialogue from '@/components/ConfirmDialogue.vue'
import ModalAyudas from '@/components/shared/ModalAyudas.vue';

export default {
    data:()=>({
        alert: false,
        alertMessage: '',
        fechas: new Date().toISOString().substring(0, 10),
        turnos: [],
        horas: [],
        hora: {
            id: 0,
            fecha: new Date().toISOString().substring(0, 10),
            turnos_id: 0,
            linea1: '',
            linea2: '',
            diario: '',
            linea3: '',
            observacion: '',
        },
        encabezado: [
            { text: 'Fecha', value: 'fecha', class:"cabecera" },
            { text: 'Turno', value: 'turnos_id', class:"cabecera" },
            { text: 'Línea 1', value: 'linea1', class:"cabecera" },
            { text: 'Línea 2', value: 'linea2', class:"cabecera" },
            { text: 'Planta Harina', value: 'diario', class:"cabecera" },
            { text: 'Planta Hidrolizado', value: 'linea3', class:"cabecera" },
            { text: 'Observación', value: 'observacion', class:"cabecera" },
            { text: 'Opciones', value: 'actions', sortable: false, class:"cabecera"},
        ],
    }),
    mounted() {
        this.cargarTurnos();
        this.cargarHoras();
    },
    methods:{
        abrirAyudas(){
            const jiji = [
                {   titulo:`Ayuda de Registro de Horas Operativas`,    tipo:`titulo`},
                {   tipo:`label`,   texto:`En esta pantalla se muestran y registran las horas que estuvieron operativas cada una de las líneas de las plantas.`},
                {   tipo:`label`,   texto:`- En la ventana de la izquierda, se crea un nuevo registro de horas operativas rellenando cada campo solicitado (fecha, turno, horas operativas de la línea 1, línea 2, planta harina en general, planta hidrolizado y, opcionalmente, una observación). Para guardar el registro, se deben rellenar todos los campos obligatorios (marcados con un *) y pulsar en el botón "Registrar".`},
                {   tipo:`label`,   texto:`- En la tabla de la derecha, se muestran todos los registros de horas operativas existentes según el rango de fechas indicado arriba de la tabla. En la columna "Opciones", estos registros se pueden eliminar (pulsando en el botón con el icono de basura) o editar (pulsando el botón con el icono del lápiz). Al editar, se agregarán los datos de ese registro a la ventana de la izquierda para su edición. Al terminar de editar, se debe pulsar el botón "Modificar". En caso de que se desee cancelar la edición, se debe pulsar nuevamente el icono con el lápiz. Si se está editando un registro, se marcará esa completa fila en la tabla con un tono más oscuro para diferenciarlas del resto.`},
            ];
            Event.$emit('mostrar_alert',jiji);
        },
        async cargarTurnos() {
            const url = `${this.base_url}turnos`;
            this.axios.get(url,this.headers).then((res)=>{
                this.turnos = res.data.data.map(turno => {
                    turno.nombre = `${turno.nombre_turno} (${turno.hora_inicio.substring(0, turno.hora_fin.length - 3)} - ${turno.hora_fin.substring(0, turno.hora_fin.length - 3)})`;
                    return turno;
                });
            }).catch((error)=>{
                console.log('error',error);
            });
        },
        async cargarHoras(){
            let url = `${this.base_url}horas`;
            if(typeof this.fechas === "object") {
                this.mostrarLoading({titulo:`Buscando horas entre ${this.fechas[0]} y ${this.fechas[1]}...`, color:'green'});
                url = url + `?fecha_ini=${this.fechas[0]}&fecha_fin=${this.fechas[1]}`
            } else {
                this.mostrarLoading({titulo:`Buscando horas...`, color:'green'});
            }

            await this.axios.get(url, this.headers).then((res)=>{
                console.log({res});
                this.horas= res.data.data.map(hora => {
                    return {
                        ...hora,
                        seleccionada: false,
                    }
                });
                this.ocultarLoading();
            }).catch((e)=>{
                this.errorMessage(e, "Error al cargar horas ");
            });
        },

        async generarRegistroHoras(){
            this.mostrarLoading({ titulo: 'Generando registro de horas operativas...', color:'green' })

            const data = { 
                ...this.hora,
                observacion: this.hora.observacion || null // Valor opcional 
            }

            let url = `${this.base_url}hora`;

            if(this.hora.id > 0){
                url = url + `/${this.hora.id}`;
            }
            await this.axios.post(url, data, this.headers).then((res)=>{
                console.log(`Hora ${this.hora.id > 0 ? 'actualizada' : 'creada'}`, res.data.data);
                this.alertMessage = `¡Hora ${this.hora.id > 0 ? 'actualizada' : 'creada'} correctamente!`;
                this.alert = true;
                this.ocultarLoading();
                this.cargarHoras();
                this.limpiarHora();
            }).catch((e)=>{
                this.errorMessage(e, `Error al ${this.hora.id > 0 ? 'actualizar' : 'crear'} registro de horas`);
            });
        },
        async eliminar(item){
            const ok = await this.$refs.confirmDialogue.show({
                title: 'Confirmar eliminación',
                message: '¿Desea eliminar registro de horas operativas?',
                okButton: 'Eliminar',
            });
            if(ok) {
                this.mostrarLoading({ titulo: `Eliminando registro de horas`, color:'green' });
                const url = `${this.base_url}horas/${item.id}`;
                await this.axios.delete(url,this.headers).then((res)=>{
                    console.log("Registro de horas eliminada correctamente");
                    this.alertMessage = "¡Hora eliminada correctamente!";
                    this.alert = true;
                    this.ocultarLoading();
                    this.cargarHoras();
                }).catch((e)=>{
                    this.errorMessage(e, "Error al eliminar registro de horas ");
                });
            }
        },
        rowClass (item) {
            return item.seleccionada ? "row-seleccionada" : "";
        },
        seleccionar(item) {
            if(this.alert) this.alert = false;

            this.horas = this.horas.map(hora => {
                if(hora.id === item.id) {
                    if(!hora.seleccionada) {
                        hora.seleccionada = true;
                        this.hora = hora;
                    } else { 
                        hora.seleccionada = false;
                        this.limpiarHora();
                    };
                } else {
                    hora.seleccionada = false;
                }
                return hora; 
            });
        },
        limpiarHora() {
            this.hora = {
                id: 0,
                fecha: new Date().toISOString().substring(0, 10),
                linea1: '',
                linea2: '',
                diario: '',
                linea3: '',
            }
        },

        ...mapMutations(['mostrarLoading', 'ocultarLoading'])
    },
    computed:{
        registro() {
            return this.hora.id ? "Modificar" : "Registrar";
        },
        campos_validos() {
            const validos = Object.entries(this.hora).every(([key, value]) => {
                // Campos que no se validan / opcionales
                if(key === "id") return true;
                if(key === "observacion") return true;
                if(key === "users_id") return true;
                if(key === "turnos_id") return typeof value === "number" && value >= 0;

                return value
            });
            return validos;
        },
        ...mapState(['base_url', 'headers'])
    },
    components:{
        DatePicker,
        ConfirmDialogue,
        'modal-ayuda': ModalAyudas,
    },

}
</script>
<style>
    .row-seleccionada {
        background-color: gainsboro !important;
    }
</style>